import { useEffect, useState } from "react";
import { listPublicTestimonials } from "@/lib/api";
import { Section } from "@/components/Section";
import { Quote } from "lucide-react";

// Hidden until the backend returns 3+ approved testimonials.
export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try { const t = await listPublicTestimonials(); setItems(t); } catch { /* empty */ }
      setLoaded(true);
    })();
  }, []);

  if (!loaded || items.length < 3) return null;

  return (
    <Section id="testimonials" eyebrow="Client Voices" title="Leaders who came in, and left with something they built."
      className="bg-white border-y border-[var(--layor-border)]">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((t, i) => (
          <blockquote key={t.id} className="lift-card bg-white border border-[var(--layor-border)] rounded-2xl p-6 flex flex-col" data-testid={`testimonial-${i}`}>
            <Quote size={18} className="text-[var(--layor-pink)]" />
            <p className="mt-4 text-[15px] text-[var(--layor-navy)] leading-relaxed">{t.quote}</p>
            <div className="mt-6 flex items-center gap-3">
              {t.photo_url ? (
                <img src={t.photo_url} alt={t.name} className="h-11 w-11 rounded-full object-cover border border-[var(--layor-border)]" />
              ) : (
                <div className="h-11 w-11 rounded-full bg-[var(--layor-gold)]/20 border border-[var(--layor-border)] flex items-center justify-center text-sm font-semibold text-[var(--layor-navy)]">
                  {t.name?.[0] || "L"}
                </div>
              )}
              <div>
                <div className="text-sm font-semibold text-[var(--layor-navy)]">{t.name}</div>
                <div className="text-xs text-[var(--layor-muted)]">{[t.title, t.organization].filter(Boolean).join(" · ")}</div>
              </div>
            </div>
          </blockquote>
        ))}
      </div>
    </Section>
  );
}
